import { css } from "@emotion/css";
import NumberLottery from "components/number-lottery/NumberLottery";
import ResultLotteryMienBac from "components/result-game/ResultLotteryMienBac";
import ResultLotteryMienNam from "components/result-game/ResultLotteryMienNam";
import TableLotteryDauDuoi from "components/result-game/TableLotteryDauDuoi";
import { colors } from "constants/theme";
import { IssueResultWinOpenNumber } from "models/lotteryModel";
import { useEffect, useState } from "react";
import { checkIsTypeLotteryMienBac, checkIsTypeLotteryMienNam } from "utils/function";


interface Props {
    winNumberList: IssueResultWinOpenNumber[];
    ltId: number;
    typeInputId: string;
}

function LotteryWinNumber(props: Props) {
    const { winNumberList, ltId, typeInputId } = props;
    const [ winNumberActive, setWinNumberActive ] = useState<IssueResultWinOpenNumber>(winNumberList[0]);
	const [showEffectOpenResult, setShowEffectOpenResult] = useState(false); //state toggle mở thưởng

    useEffect(() => {
        if (winNumberList.length > 0) {
            setWinNumberActive(winNumberList[0]);
        }
    }, [winNumberList]);

    const changeIssue = (issue: string) => {
        const resultSelect = winNumberList.find((item) => item.issue === issue);
        setShowEffectOpenResult(true);
        if(resultSelect) {
            setWinNumberActive(resultSelect);
            setShowEffectOpenResult(false);
        }
    };

    return (
        <div className={styles.wrap}>
            <div className={styles.result}>
                <a href={`https://asialoto.top/detail;numHis=0;ltid=${ltId}`} target="_blank" rel="noopener noreferrer" >
                    <img src={require('assets/images/header/ketqua.png')} alt="" />
                </a>
            </div>
            <div className={styles.tableResult}>
                <h6>Kết quả: <span>{winNumberActive.issue}</span></h6>
                <div className={styles.specialLotteryHistory}>
                    {winNumberList.length > 0
                        ? winNumberActive.code[0].split('').map((num, index) => <NumberLottery value={Number(num)} isRun={showEffectOpenResult} key={index} />)
                        : [1, 2, 3, 4, 5].map((num) => <span key={num}>?</span>)}
                </div>
            </div>
            <div className={styles.detailResult}>
                <div className={styles.issueList}>
                    <p>Lượt xổ</p>
                    <select
                        value={winNumberActive.issue}
                        onChange={(e) => changeIssue(e.target.value)}
                        className={styles.selectDropdown} // Nếu bạn cần style riêng cho select
                        >
                        {winNumberList.map((item, index) => (
                            <option key={index} value={item.issue}>
                            {item.issue}
                            </option>
                        ))}
                    </select>
                </div>
                {checkIsTypeLotteryMienNam(ltId) && <ResultLotteryMienNam resultList={winNumberActive.code} borderColor={colors.borderPrimary} typeInputId={typeInputId} />}
                {checkIsTypeLotteryMienBac(ltId) && <ResultLotteryMienBac resultList={winNumberActive.code} borderColor={colors.borderPrimary} typeInputId={typeInputId} />}
            </div>
            <div style={{ fontSize: '13px' }}>
                <TableLotteryDauDuoi resultList={winNumberActive.code} methodid={117} borderColor={colors.borderPrimary} />
            </div>
        </div>
    )
}

const styles = {
    specialLotteryHistory: css`
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 0;

        span {
            width: 36px;
            height: 36px;
            line-height: 34px;
            text-align: center;
            border-radius: 36px;
            background: ${colors.white};
            border: 1px solid ${colors.borderPrimary};
            color: ${colors.blackText};
            font-size: 20px;
            font-weight: 600;
        }
    `,
    wrap: css`
        display: flex;
        gap: 6px;
        flex-direction: column;
        width: 100%;
    `,
    detailResult: css`
        background: ${colors.white};
        padding: 5px;
        border-radius: 10px;
    `,
    selectDropdown: css`
        background: transparent;
        border: 0;
        font-size: 16px;
        text-align: center;
        outline: none;
        width: 90%;
        color: #f4ff23;
        font-weight: 700;
    `,
    issueList: css`
        background: linear-gradient(to bottom, #1853f0, #011e98);
        border-radius: 5px;
        padding: 10px 10px;
        display: flex;
        align-items: center;
        margin: 0 auto 10px;
        p {
            width: 30%;
        }
    `,
    issueItem: css`
        padding: 4px 0;
        text-align: center;
        min-width: 180px;
        cursor: pointer;
        border-radius: 0;
        margin: 2px 0;
        position: relative;
        color: #000;
        &::before {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 0;
            width: 100%;
            height: 1px;
            background: ${colors.borderTable};
        }
        &.active {
            background: ${colors.primary};
            color: ${colors.white};
        }
        &:last-child {
            border-bottom: none;
        }
    `,
    result: css`
        text-align: center;
        a {
            display: inline-block;
            position: relative;

            &::before {
                content: '';
                position: absolute;
                top: -5px;
                left: -5px;
                right: -5px;
                bottom: -5px;
                background: linear-gradient(45deg, #ff6b35, #f7931e, #ffd700, #ff6b35);
                background-size: 300% 300%;
                border-radius: 15px;
                opacity: 0;
                transition: opacity 0.3s ease;
                animation: gradientShift 3s ease infinite;
                z-index: -1;
            }

            &:hover::before {
                opacity: 0.6;
            }

            &:hover img {
                transform: scale(1.05) translateY(-3px);
                filter: drop-shadow(0 8px 16px rgba(255, 107, 53, 0.4));
            }
        }

        img {
            width: 80%;
            margin: 0 auto;
            display: block;
            border-radius: 10px;
            transition: all 0.3s ease;
            filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
            animation: floatBounce 3s ease-in-out infinite;
        }

        @keyframes floatBounce {
            0%, 100% {
                transform: translateY(0px);
            }
            50% {
                transform: translateY(-8px);
            }
        }

        @keyframes gradientShift {
            0%, 100% {
                background-position: 0% 50%;
            }
            50% {
                background-position: 100% 50%;
            }
        }
    `,
    tableResult: css`
        display: flex;
        flex-direction: column;
        font-size: 14px;
        background: linear-gradient(to bottom, #1853f0, #011e98);
        border-radius: 5px;
        position: relative;
        h6 {
            padding: 12px;
            text-align: center;
            span {
                color: #f4ff23;
            }
        }
    `,
};

export default LotteryWinNumber;
